/**
 * `setValueAs` transformer for optional numeric inputs registered with React
 * Hook Form. Returns `undefined` for empty/blank values instead of `NaN`,
 * so an empty optional field passes `z.coerce.number().optional()` validation.
 *
 * Prefer this over `{ valueAsNumber: true }` for optional number fields —
 * `valueAsNumber` turns an empty input into `NaN`, which fails Zod's number
 * check even when the field is optional.
 */
export const optionalNumberValueAs = (value: unknown): number | undefined => {
  if (value === '' || value === null || value === undefined) {
    return undefined;
  }
  const num = Number(value);
  return isNaN(num) ? undefined : num;
};
